"use client";

import React, { useState, useEffect, useRef } from "react";
import Img1 from "../../assets/img/website-images/Sir.avif"
import Img2 from "../../assets/img/website-images/Mam.avif"

const leaders = [
  {
    title: "WHERE PURPOSE MEETS PROGRESS",
    body: "At Anjanadri Group Of Institutions (AGI), we believe that true education lies beyond textbooks—it lies in shaping character, nurturing innovation, and building a future that is both skilled and compassionate. We are committed to offering a holistic, ethical, and globally competitive education that empowers every student to rise with confidence and contribute meaningfully to society.",
    role: "Founder & Chairman",
    name: "Sri. Muniraju",
    image: Img1
  },
  {
    title: "SHAPING THE LEADERS OF TOMORROW",
    body: "Our focus on value-based education, cutting-edge technology, and community outreach enables students to become well-rounded leaders. We're dedicated to nurturing the next generation of innovators, thinkers, and change-makers. Our students are equipped with the skills, knowledge, and values to succeed. We're proud to be part of their journey.",
    role: "Chairperson",
    name: "Smt Pushpa Muniraju",
    image: Img2
  },
];

export default function LeadershipSection() {
  const [current, setCurrent] = useState(0);
  const [animating, setAnimating] = useState(false);
  const intervalRef = useRef(null);

  const goTo = (index) => {
    if (animating || index === current) return;
    setAnimating(true);
    setTimeout(() => {
      setCurrent(index);
      setAnimating(false);
    }, 300);
  };

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      setCurrent((prev) => (prev + 1) % leaders.length);
    }, 6000);
    return () => clearInterval(intervalRef.current);
  }, []);

  const leader = leaders[current];

  return (
    <>
      {/* ── Chairman / Chairperson Slider ── */}
      <section
        style={{
          backgroundColor: "#0C72BA",
          minHeight: "520px",
          position: "relative",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
        }}
      >
        {/* subtle background pattern */}
        <div
          style={{
            position: "absolute",
            inset: 0,
            backgroundImage:
              "radial-gradient(circle at 20% 50%, rgba(255,255,255,0.04) 0%, transparent 60%)",
            pointerEvents: "none",
          }}
        />

        <div
          style={{
            maxWidth: "1400px",
            width: "100%",
            margin: "0 auto",
            padding: "60px 80px",
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: "40px",
            opacity: animating ? 0 : 1,
            transition: "opacity 0.3s ease",
          }}
        >
          {/* Left: Text Content */}
          <div style={{ flex: 1, maxWidth: "620px" }}>
            <h2
              style={{
                color: "#ffffff",
                fontSize: "clamp(1.5rem, 3vw, 2.4rem)",
                fontWeight: 700,
                letterSpacing: "0.04em",
                marginBottom: "28px",
                lineHeight: 1.2,
                textTransform: "uppercase",
              }}
            >
              {leader.title}
            </h2>

            <p
              style={{
                color: "rgba(255,255,255,0.88)",
                fontSize: "clamp(0.85rem, 1.2vw, 1rem)",
                lineHeight: 1.75,
                marginBottom: "40px",
                maxWidth: "540px",
              }}
            >
              {leader.body}
            </p>

            {/* Signature line */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <div
                style={{
                  flex: 1,
                  maxWidth: "280px",
                  height: "1px",
                  backgroundColor: "rgba(255,255,255,0.35)",
                }}
              />
              <div style={{ textAlign: "left" }}>
                <p
                  style={{
                    color: "rgba(255,255,255,0.6)",
                    fontSize: "0.72rem",
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    marginBottom: "4px",
                  }}
                >
                  {leader.role}
                </p>
                <p
                  style={{
                    color: "#ffffff",
                    fontSize: "1.15rem",
                    fontWeight: 600,
                    letterSpacing: "0.02em",
                  }}
                >
                  {leader.name}
                </p>
              </div>
            </div>
          </div>

          {/* Right: Portrait with orange ring */}
          <div
            style={{
              flexShrink: 0,
              width: "clamp(280px, 28vw, 400px)",
              height: "clamp(280px, 28vw, 400px)",
              borderRadius: "50%",
              border: "0px solid #F27024",
              overflow: "hidden",
              position: "relative",
              boxShadow: "0 0 0 ",
            }}
          >
            <img
              src={leader.image}
              alt={leader.name}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: "top center",
                display: "block",
              }}
            />
          </div>
        </div>

        {/* Slide dots */}
        <div
          style={{
            position: "absolute",
            bottom: "24px",
            left: "50%",
            transform: "translateX(-50%)",
            display: "flex",
            gap: "10px",
          }}
        >
          {leaders.map((_, i) => (
            <button
              key={i}
              onClick={() => goTo(i)}
              aria-label={`Go to slide ${i + 1}`}
              style={{
                width: i === current ? "28px" : "10px",
                height: "10px",
                borderRadius: "6px",
                border: "none",
                backgroundColor:
                  i === current ? "#F27024" : "rgba(255,255,255,0.45)",
                cursor: "pointer",
                padding: 0,
                transition: "all 0.3s ease",
              }}
            />
          ))}
        </div>
      </section>

      {/* ── Principal's Desk ── */}
      <section
        style={{
          backgroundColor: "#ffffff",
          padding: "72px 80px",
          maxWidth: "1400px",
          margin: "0 auto",
        }}
      >
        {/* Section label */}
        <p
          style={{
            color: "#F27024",
            fontSize: "0.8rem",
            fontWeight: 600,
            letterSpacing: "0.12em",
            textTransform: "uppercase",
            marginBottom: "8px",
            textAlign: "center",
          }}
        >
          Message
        </p>
        <h2
          style={{
            color: "#231F20",
            fontSize: "clamp(1.5rem, 2.5vw, 2rem)",
            fontWeight: 700,
            marginBottom: "40px",
            textAlign: "center",
          }}
        >
          Principal's Desk
        </h2>

        <div
          style={{
            display: "flex",
            gap: "56px",
            alignItems: "flex-start",
          }}
        >
          {/* Blue accent bar */}
          <div
            style={{
              flexShrink: 0,
              width: "5px",
              alignSelf: "stretch",
              backgroundColor: "#0C72BA",
              borderRadius: "3px",
            }}
          />

          <div style={{ flex: 1 }}>
            <h3
              style={{
                color: "#0C72BA",
                fontSize: "1.15rem",
                fontWeight: 600,
                marginBottom: "20px",
              }}
            >
              Welcome to the noble profession of Pharmacy!
            </h3>

            <div
              style={{
                color: "#3a3a3a",
                fontSize: "clamp(0.875rem, 1.1vw, 0.975rem)",
                lineHeight: 1.9,
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              <p>
                Pharmacy is a dynamic and ever-evolving field that plays a vital
                role in healthcare and society. At our institution, we are
                committed to providing quality education that blends strong
                academic foundations with practical exposure. Our curriculum,
                aligned with the standards of Rajiv Gandhi University of Health
                Sciences, recognised by Pharmacy Council of India, &amp;
                approved by Government of Karnataka, ensures that students
                receive comprehensive training in pharmaceutical sciences.
              </p>
              <p>
                We emphasize hands-on laboratory learning, research orientation,
                ethical values, and professional discipline. Our experienced
                faculty members are dedicated mentors who guide students not
                only academically but also in developing leadership qualities,
                communication skills, and social responsibility.
              </p>
              <p>
                In today's competitive healthcare environment, pharmacists are
                more than medicine dispensers—they are healthcare advisors,
                researchers, and innovators. At Anjanadri Institute of Pharmacy, we
                strive to equip our students with the confidence and competence
                to meet global challenges and contribute meaningfully to the
                healthcare sector.
              </p>

              {/* Quote highlight */}
              <blockquote
                style={{
                  margin: "8px 0",
                  padding: "18px 24px",
                  backgroundColor: "#f0f7ff",
                  borderLeft: "4px solid #F27024",
                  borderRadius: "0 8px 8px 0",
                  color: "#0C72BA",
                  fontWeight: 600,
                  fontSize: "1rem",
                  fontStyle: "italic",
                  letterSpacing: "0.01em",
                }}
              >
                "SERVICE TO PHARMACY IS SERVICE TO HUMANITY"
              </blockquote>

              <p>
                I wish students all success in their professional and future
                endeavors!
              </p>
            </div>

            {/* Principal signature */}
            <div
              style={{
                marginTop: "32px",
                paddingTop: "24px",
                borderTop: "1px solid rgba(12,114,186,0.15)",
                display: "flex",
                alignItems: "center",
                gap: "16px",
              }}
            >
              <div
                style={{
                  width: "48px",
                  height: "48px",
                  borderRadius: "50%",
                  backgroundColor: "#0C72BA",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#fff",
                  fontWeight: 700,
                  fontSize: "1.1rem",
                  flexShrink: 0,
                }}
              >
                CN
              </div>
              <div>
                <p
                  style={{
                    color: "#231F20",
                    fontWeight: 700,
                    fontSize: "1rem",
                    marginBottom: "2px",
                  }}
                >
                  Dr Bhavya MV
                </p>
                <p
                  style={{
                    color: "#F27024",
                    fontSize: "0.8rem",
                    fontWeight: 600,
                    letterSpacing: "0.06em",
                    textTransform: "uppercase",
                  }}
                >
                  Principal &amp; Professor
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
